import React, { ReactNode } from 'react'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import TextField from '@mui/material/TextField'

import { useAppDispatch } from 'redux/Hook'
import { IMPORT_FILTER_VALUES } from 'lib/participants/Constants'
import { updateFilter } from 'redux/slices/FilterBuilder'
import { FilterItem } from 'types/FilterBuilder'

type Props = {
  item: FilterItem
  index: number
}

const renderSelectOptions = (): ReactNode => {
  const { t } = useTranslation()
  return IMPORT_FILTER_VALUES.map((value) => {
    return (
      <MenuItem key={value} value={value !== 'none' ? value : ''}>
        <Stack direction="row" spacing={1}>
          <Typography variant="body1">
            {t(`filters.participantImport.${value}`)}
          </Typography>
        </Stack>
      </MenuItem>
    )
  })
}

const ImportFilter = ({ item, index }: Props) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { defaultOpen } = item

  return (
    <FormControl variant="standard" fullWidth>
      <TextField
        select
        color="primary"
        label={t(`filters.participantImport.label`)}
        value={item.value}
        onChange={(event) =>
          dispatch(updateFilter({ item: { value: event.target.value }, index }))
        }
        InputProps={{
          'data-testid': 'import-input',
        }}
        SelectProps={{
          MenuProps: {
            //Extending the menu types to add custom prop using
            //typescript's module Augmentation
            'data-testid': 'import-menu',
          },
          defaultOpen: defaultOpen,
        }}
        size="small"
      >
        {renderSelectOptions()}
      </TextField>
    </FormControl>
  )
}

export default ImportFilter
